export enum TrackedEvents {
  EVIDENCE_UPLOAD_SOP_FAILURE = 'EVIDENCE_UPLOAD_SOP_FAILURE',
  EVIDENCE_UPLOAD_SOP_SUCCESS = 'EVIDENCE_UPLOAD_SOP_SUCCESS',

  // Sell Price
  SELL_PRICE_VIEW_PRICE_PAGE = 'SELL_PRICE_VIEW_PRICE_PAGE',
  SELL_PRICE_ACCEPT_OFFER_SUBMIT = 'SELL_PRICE_ACCEPT_OFFER_SUBMIT',
  SELL_PRICE_ACCEPT_OFFER_CANCEL = 'SELL_PRICE_ACCEPT_OFFER_CANCEL',
  SELL_PRICE_ACCEPT_OFFER = 'SELL_PRICE_ACCEPT_OFFER',
  SELL_PRICE_QUICK_COUNTER_OFFER = 'SELL_PRICE_CLICK_QUICK_COUNTER_OFFER',
  SELL_PRICE_CONTACT_AM = 'SELL_PRICE_CONTACT_AM',

  // Quality Reports
  REPORT_SHARE_QUALITY_REPORT = 'REPORT_SHARE_QUALITY_REPORT',
  QUALITY_REPORT_VIEW = 'QUALITY_REPORT_VIEW',
  QUALITY_REPORT_CLICK_HEADER_IMAGE = 'QUALITY_REPORT_CLICK_HEADER_IMAGE',
  QUALITY_REPORT_CLICK_CATEGORY_IMAGES = 'QUALITY_REPORT_CLICK_CATEGORY_IMAGES',
  QUALITY_REPORT_CLICK_IMAGE_CATEGORY_FILTER = 'QUALITY_REPORT_CLICK_IMAGE_CATEGORY_FILTER',
  QUALITY_REPORT_CLICK_SHOW_ALL_MEDIA = 'QUALITY_REPORT_CLICK_SHOW_ALL_MEDIA',
  QUALITY_REPORT_CLICK_IMAGE = 'QUALITY_REPORT_CLICK_IMAGE',
  QUALITY_REPORT_TOGGLE_ANNOTATIONS = 'QUALITY_REPORT_TOGGLE_ANNOTATIONS',
  QUALITY_REPORT_TOGGLE_ANNOTATION_CATEGORY = 'QUALITY_REPORT_TOGGLE_ANNOTATION_CATEGORY',

  // Evidence Camera Access
  EVIDENCE_CAMERA_ACCESS_PERMISSIONS_DENIED = 'EVIDENCE_CAMERA_ACCESS_PERMISSIONS_DENIED',

  // BUY MATERIAL
  BUY_LISTING_MAKE_OFFER_START = 'BUY_LISTING_MAKE_OFFER_START',
  BUY_LISTING_MAKE_OFFER_SUBMIT = 'BUY_LISTING_MAKE_OFFER_SUBMIT',
  BUY_LISTING_NO_RESULTS_FOUND = 'BUY_LISTING_NO_RESULTS_FOUND',
  BUY_LISTING_VIEW_BUY_PAGE = 'BUY_LISTING_VIEW_BUY_PAGE',
  BUY_LISTING_OPEN_FILTER_MENU = 'BUY_LISTING_OPEN_FILTER_MENU',
  BUY_LISTING_APPLY_FILTERS = 'BUY_LISTING_APPLY_FILTERS',
  BUY_LISTING_VIEW_QR = 'BUY_LISTING_VIEW_QR',
  BUY_LISTING_VIEW_OTHER_MATERIAL = 'BUY_LISTING_VIEW_OTHER_MATERIAL',
  BUY_LISTING_BACK_ARROW_QR = 'BUY_LISTING_BACK_ARROW_QR',
  BUY_LISTING_VIEW_COUNTER_OFFER = 'BUY_LISTING_VIEW_COUNTER_OFFER',
  BUY_LISTING_CO_VIEW_SUBMIT_NEW_OFFER = 'BUY_LISTING_CO_VIEW_SUBMIT_NEW_OFFER',
  BUY_LISTINGS_VIEW_GUIDE_PRICE = 'BUY_LISTINGS_VIEW_GUIDE_PRICE',
  BUY_LISTING_GUIDE_PRICE_NOT_AVAILABLE = 'BUY_LISTING_GUIDE_PRICE_NOT_AVAILABLE',
  BUY_LISTINGS_GUIDE_PRICE_SELECT = 'BUY_LISTINGS_GUIDE_PRICE_SELECT',
  MESSAGE_ACCOUNT_MANAGER_OPEN = 'MESSAGE_ACCOUNT_MANAGER_OPEN',
  MESSAGE_ACCOUNT_MANAGER_SELECT = 'MESSAGE_ACCOUNT_MANAGER_SELECT',

  // Quality buyer
  QUALITY_BUYER_SAMPLE_CREATED = 'QUALITY_BUYER_SAMPLE_CREATED',
  QUALITY_BUYER_SAMPLE_DELETED = 'QUALITY_BUYER_SAMPLE_DELETED',
  QUALITY_BUYER_SAMPLE_EVIDENCE_UPLOADED = 'QUALITY_BUYER_SAMPLE_EVIDENCE_UPLOADED',
  QUALITY_BUYER_SAMPLE_EVIDENCE_REMOVED = 'QUALITY_BUYER_SAMPLE_EVIDENCE_REMOVED',
  QUALITY_BUYER_BALE_EVIDENCE_UPLOADED = 'QUALITY_BUYER_BALE_EVIDENCE_UPLOADED',
  QUALITY_BUYER_BALE_EVIDENCE_REMOVED = 'QUALITY_BUYER_BALE_EVIDENCE_REMOVED',

  // Trading dashboard
  TRADING_DASHBOARD_VIEW = 'TRADING_DASHBOARD_VIEW',
  TRADING_DASHBOARD_SEARCH = 'TRADING_DASHBOARD_SEARCH',
  TRADING_DASHBOARD_SEND_AUTO = 'TRADING_DASHBOARD_SEND_AUTO',
  TRADING_DASHBOARD_SEND_MANUAL = 'TRADING_DASHBOARD_SEND_MANUAL',
  TRADING_DASHBOARD_SHARE_WITH_AM = 'TRADING_DASHBOARD_SHARE_WITH_AM',

  // Inspection samples
  INSPECTION_SAMPLE_CREATE = 'INSPECTION_SAMPLE_CREATE',
  INSPECTION_SAMPLE_EVIDENCE_UPLOADED = 'INSPECTION_SAMPLE_EVIDENCE_UPLOADED',
  INSPECTION_SAMPLE_EVIDENCE_REMOVED = 'INSPECTION_SAMPLE_EVIDENCE_REMOVED',
  INSPECTION_SAMPLE_SUBMITTED = 'INSPECTION_SAMPLE_SUBMITTED',
  INSPECTION_SAMPLE_EDIT_CANCELLED = 'INSPECTION_SAMPLE_EDIT_CANCELLED',
  INSPECTION_SAMPLE_CAMERA_OPENED = 'INSPECTION_SAMPLE_CAMERA_OPENED',
  INSPECTION_SAMPLE_CAMERA_CLOSED = 'INSPECTION_SAMPLE_CAMERA_CLOSED',

  // Purchaser Pipeline
  PURCHASER_PIPELINE_VIEW = 'PURCHASER_PIPELINE_VIEW',
  PURCHASER_PIPELINE_CLICK_CHART = 'PURCHASER_PIPELINE_CLICK_CHART',
  PURCHASER_PIPELINE_CLICK_AVAILBALE_MATERIAL = 'PURCHASER_PIPELINE_CLICK_AVAILBALE_MATERIAL',
  PURCHASER_PIPELINE_CLICK_SALES_ORDERS_TAB = 'PURCHASER_PIPELINE_CLICK_SALES_ORDERS_TAB',
  PURCHASER_PIPELINE_CLICK_SHIPMENTS_TAB = 'PURCHASER_PIPELINE_CLICK_SHIPMENTS_TAB',
  PURCHASER_EXPORT_SUMMARY_REQUESTED = 'PURCHASER_EXPORT_SUMMARY_REQUESTED',

  // Purchaser Tracking
  PURCHASER_TRACKING_CLICK_SHIPMENT_TRACKER = 'PURCHASER_TRACKING_CLICK_SHIPMENT_TRACKER',
  PURCHASER_TRACKING_CLICK_SIGN_SALES_ORDER = 'PURCHASER_TRACKING_CLICK_SIGN_SALES_ORDER',
  PURCHASER_TRACKING_CLICK_SHIPMENT_DOCUMENTS = 'PURCHASER_TRACKING_CLICK_SHIPMENT_DOCUMENTS',
  PURCHASER_TRACKING_CLICK_SALES_ORDER_DOCUMENTS = 'PURCHASER_TRACKING_CLICK_SALES_ORDER_DOCUMENTS',
  PURCHASER_TRACKING_CLICK_LOADS = 'PURCHASER_TRACKING_CLICK_LOADS',
  PURCHASER_TRACKING_CLICK_PAYMENT_DETAILS = 'PURCHASER_TRACKING_CLICK_PAYMENT_DETAILS',
  PURCHASER_TRACKING_CLICK_TONNAGE_DETAILS = 'PURCHASER_TRACKING_CLICK_TONNAGE_DETAILS',
  PURCHASER_TRACKING_CLICK_COMMENTS = 'PURCHASER_TRACKING_CLICK_COMMENTS',

  // Quality control

  QUALITY_CONTROL_ANALYSIS_CAMERA_OPENED = 'QUALITY_CONTROL_CAMERA_OPENED',
  QUALITY_CONTROL_ANALYSIS_CANCEL = 'QUALITY_CONTROL_SESSIONS_ANALYSIS_CANCEL',
  QUALITY_CONTROL_ANALYSIS_COMPLETE = 'QUALITY_CONTROL_SESSIONS_ANALYSIS_COMPLETE',
  QUALITY_CONTROL_ANALYSIS_FILE_SELECT = 'QUALITY_CONTROL_FILE_UPLOAD',
  QUALITY_CONTROL_ANALYSIS_MATERIAL_FORM_SELECT = 'QUALITY_CONTROL_SESSIONS_MATERIAL_FORM_SELECT',
  QUALITY_CONTROL_ANALYSIS_MATERIAL_SELECT = 'QUALITY_CONTROL_SESSIONS_MATERIAL_SELECT',
  QUALITY_CONTROL_ANALYSIS_START = 'QUALITY_CONTROL_SESSIONS_ANALYSIS_START',
  QUALITY_CONTROL_SESSION_BACK_TO_INSPECTIONS_CLICK = 'QUALITY_CONTROL_SESSIONS_BACK_TO_INSPECTIONS_CLICK',
  QUALITY_CONTROL_SESSION_EDIT_EVIDENCE = 'QUALITY_CONTROL_SESSION_EDIT_EVIDENCE',
  QUALITY_CONTROL_SESSION_SHARE_CLICK = 'QUALITY_CONTROL_SESSIONS_SHARE_CLICK',
  QUALITY_CONTROL_SESSION_SHARE_OPTION_CLICK = 'QUALITY_CONTROL_SESSION_SHARE_OPTION_CLICK',
  QUALITY_CONTROL_SESSION_TAB_CLICK = 'QUALITY_CONTROL_SESSIONS_TAB_CLICK',
  QUALITY_CONTROL_SESSIONS_VIEW_LIST = 'QUALITY_CONTROL_SESSIONS_VIEW_LIST',
  QUALITY_CONTROL_SESSIONS_VIEW_SESSION = 'QUALITY_CONTROL_SESSIONS_VIEW_SESSION',

  // Site material sessions
  SITE_MATERIAL_SESSIONS_VIEW_LIST = 'SITE_MATERIAL_SESSIONS_VIEW_LIST',
  SITE_MATERIAL_SESSIONS_VIEW_SESSION = 'SITE_MATERIAL_SESSIONS_VIEW_SESSION',
  SITE_MATERIAL_SESSIONS_ANALYSIS_START = 'SITE_MATERIAL_SESSIONS_ANALYSIS_START',
  SITE_MATERIAL_SESSION_BACK_TO_SESSIONS_CLICK = 'SITE_MATERIAL_SESSION_BACK_TO_SESSIONS_CLICK',
  SITE_MATERIAL_SESSION_SHARE_CLICK = 'SITE_MATERIAL_SESSION_SHARE_CLICK',
  SITE_MATERIAL_SESSION_SHARE_OPTION_CLICK = 'SITE_MATERIAL_SESSION_SHARE_OPTION_CLICK',
  SITE_MATERIAL_SESSION_ANALYSIS_CANCEL = 'SITE_MATERIAL_SESSION_ANALYSIS_CANCEL',

  // Help guides
  HELP_GUIDE_LINK_CLICK = 'HELP_GUIDE_LINK_CLICK',
}
